import { Dispatch } from 'redux';
import { OrderRepositoryImpl } from '../../../data/repositories/order-repository-impl';
import { OrderUsecaseImpl } from '../../../domain/usecases/order-usecase';

import {
  ORDERS_LOAD_REQUEST,
  ORDERS_LOAD_SUCCESS,
  ORDERS_LOAD_FAILURE
} from '../types/orders-types';
import {
  LOADING_FAILURE,
  LOADING_REQUEST,
  LOADING_SUCCESS
} from '../../../../../core/redux/types/loading-types';

export const getOrders = (client_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ORDERS_LOAD_REQUEST });

    try {
      const orderRepository = new OrderRepositoryImpl();
      const orderUsecase = new OrderUsecaseImpl(orderRepository);

      const result = await orderUsecase.GetOrders(client_id);

      dispatch({ type: ORDERS_LOAD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: ORDERS_LOAD_FAILURE, error });
    }
  };
};

export const terminateOrder = (client_id: string, order_id: string, trip_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });

    try {
      const orderRepository = new OrderRepositoryImpl();
      const orderUsecase = new OrderUsecaseImpl(orderRepository);

      const result = await orderUsecase.TerminateOrder(client_id, order_id, trip_id);

      dispatch({ type: LOADING_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error });
    }
  };
};
